"use client";

import { useEffect } from "react";

export default function ThemeClient() {
  useEffect(() => {
    const applyTheme = (dark: boolean) => {
      document.documentElement.setAttribute(
        "data-theme",
        dark ? "dark" : "light"
      );
      document.body.classList.remove("light", "dark");
      document.body.classList.add(dark ? "dark" : "light");
    };

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    applyTheme(mediaQuery.matches);

    const listener = (e: MediaQueryListEvent) => applyTheme(e.matches);
    mediaQuery.addEventListener("change", listener);

    return () => mediaQuery.removeEventListener("change", listener);
  }, []);

  return null;
}
